import React from 'react';


const indexIcon = (indexImage, indexProgress) => `./icon${indexImage <= indexProgress + 1 ? indexImage: indexImage +'gray'}.svg`;


const getImg = (width = 25, className,  indexProgress, indexImage) => (
    <img
    width={width}
    className={className}
    src={require(`${indexIcon(indexImage, indexProgress)}`).default}
    alt="imagen"
  />
);

export const Img1 = ({ width = 75, className }) => (
    <img
      width={width}
      className={className}
      src={require(`./icon1.svg`).default}
      alt="imagen"
    />
);

export const Img2 = ({ width = 75, className, indexProgress }) =>   
    getImg(width, className, indexProgress, 2);
    
export const Img3 = ({ width = 75, className, indexProgress }) =>
    getImg(width, className, indexProgress, 3);

export const IconOk = ({classNameIcon= ''}) => ( 
    <img className={classNameIcon} src={require(`./iconOk.svg`).default} alt="imagen" />
);
export const IconError = ({classNameIcon= ''}) => ( 
    <img className={classNameIcon} src={require(`./iconError.svg`).default} alt="imagen" />
);

export const IconNext = ({ width = 25 }) => (
    <img width={width} className="icon-left" src={require(`./arrow-right.svg`).default} alt="imagen" />
);

export const IconBack = ({ width = 25 }) => (
    <img width={width} className="icon-back" src={require(`./arrow-left.svg`).default} alt="imagen" />
);

export const IconInfo   = ({ width = 25 }) => (
    <img className="icon-info-ca" src={require(`./iconInfo.svg`).default} alt="imagen" />
);